import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Select from "react-select";
import axios from "axios";
import * as Yup from "yup";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import {
    ALREADY_EXIST,
    ERROR_MESSAGE,
    SUCCESS_MESSAGE,
    CUSTOM_SELECT_DROPDOWN_STYLE 
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "addAccountTypeDetails";
let PERMISSION_EDIT = "editAccountTypeDetails";
let PERMISSION_DELETE = "deleteAccountTypeDetails"

let selectData = [];
const AccountType = (props) => {
    const loginUserId = localStorage.getItem("ID");
    const token = localStorage.getItem("Token");
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [sortingId, setSortingId] = useState(4);
    const [sortingDirection, setSortingDirection] = useState("desc");
    const [searchtext, setSearchText] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [acoounttypedata, setAcoounttypedata] = useState([]);
    const [selectedAccountType, setselectedAccountType] = useState(0);// store Selected AccountTypeId get from SelectbyId
    const [formValues, setFormValues] = useState({ ID: 0, Name: "" });

    const handleListData = (filtertext) => {
        setLoading(true);
        axios
            .get(
                `${config.accountingBaseUrl}/chartofaccounts/accounttaxformselectall?filtertext=${filtertext}`,
                {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        Authorization: token,
                    },
                }
            )
            .then((res) => {
                console.log(res.data.ResponseData[0].TotalRecord);
                setData(res.data.ResponseData);
                setTotalRows(res.data.ResponseData[0]?.TotalRecord);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };

    // const selectStyles = {
    //     control: (provided) => ({
    //         ...provided,
    //         width: "100%",
    //         height: "40px",
    //         position: "relative",
    //     }), // dropdown input css
    //     menu: () => ({
    //         boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
    //         position: "absolute",
    //         background: "#f8f8f8",
    //         width: "100%",
    //         zIndex: 99,
    //     }),// dropdown menu css
    // };

    const formatDate = (string) => {
        var options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(string).toLocaleDateString([], options);
    };

    const validationSchema = Yup.object().shape({
        Name: Yup.string().required("Name is required"),
    });

    const handledropdwon = (values) => {
        axios
            .get(`${config.accountingBaseUrl}/chartofaccounts/accoutdetailtypeddl`, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                },
            })
            .then((res) => {
                console.log("::>>>", res);
                setAcoounttypedata(res.data.ResponseData);

                // return res;
            });
    }

    const handleManageDataPopup = () => {
        const clearData = {
            ID: 0,
            Name: "",
        };
        setFormValues(clearData);
        setselectedAccountType(0);
    };

    const handleUpdate = (pID) => {
        console.log(pID);
        setLoading(true);
        axios
            .get(`${config.accountingBaseUrl}/chartofaccounts/accounttaxformselectbyid?id=${pID}`, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                },
            })
            .then((res) => {
                const AccountDetailsData = res.data.ResponseData[0];
                console.log("AccountDetailsData", AccountDetailsData);

                const data = {
                    ID: AccountDetailsData.ID,
                    Name: AccountDetailsData.Name,
                };
                setFormValues(data);
                AccountTypeList.map((selectedAccounttype) => {
                    if (selectedAccounttype.value === AccountDetailsData.AccountTypeID) {
                        setselectedAccountType(selectedAccounttype);
                        console.log(selectedAccountType);
                    }
                });
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };

    let AccountTypeList = [];
    const AccTypes = acoounttypedata.map((u, i) => {
        AccountTypeList[i] = { label: u.Name, value: u.Id };
    });

    const columns = [
        {
            name: "Sr. No.",
            selector: (row, index) => index + 1,
            width: "10%",
            sortable: true,
        },
        {
            name: "Name",
            selector: "Name",
            sortable: true,
        },
        {
            name: "Account Types",
            selector: "AccountTypes",
            sortable: true,
        },

        {
            name: "Created On",
            selector: (row) => formatDate(row.CreatedDate),
            sortable: true,
        },
        {
            name: "Action",
            width: "20%",
            cell: (row) => (
                <>
                    {checkUserPermission(PERMISSION_EDIT) ? (
                        <Link
                            className="me-3"
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#ManageDataModal"
                            data-backdrop="static"
                            data-keyboard="false"
                            onClick={() => handleUpdate(row.ID)}
                        >
                            <i class="fa fa-edit text-warning fa-2x" title="Edit"></i>
                        </Link>
                    ) : (
                        ""
                    )}
                    {checkUserPermission(PERMISSION_DELETE) ? (
                        <Link
                            className="confirm-text"
                            to="#"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#DeleteConfirmationModal"
                            onClick={() => handleDeletePopup(row.ID)}
                        >
                            <i
                                className="fa fa-trash text-red fa-2x"
                                data-bs-toggle="tooltip"
                                title="Delete"
                            ></i>
                        </Link>
                    ) : (
                        ""
                    )}
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleDeletePopup = (pID) => {
        console.log(pID);
        const deleteRequestParam = {
            id: pID,
        };
        localStorage.setItem(
            "DeleteRequestParam",
            JSON.stringify(deleteRequestParam)
        );
    };

    const handleSubmit = (values) => {
        console.log("selectAcounttype", values.Name, selectedAccountType.value);
        setLoading(true);
        axios
            .post(
                `${config.accountingBaseUrl}/chartofaccounts/accounttaxformupsert`,
                {
                    id: values.ID,
                    name: values.Name,
                    accountdetailtypeid: selectedAccountType.value,
                    loginuserid: loginUserId,
                    isactive: 1,

                },
                {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: token,
                    },
                }
            )
            .then((res) => {
                if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
                    toastSuccess(SUCCESS_MESSAGE);
                    window.location.reload();
                } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                ) {
                    toastError("Name" + ALREADY_EXIST);
                } else {
                    toastError(ERROR_MESSAGE);
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const handleSelectedRowsChange = (e) => {
        if (e.selectedRows.length > 0) {
            setSelectedData(e.selectedRows.map((x) => x.ID));
            selectData[currentPage] = e.selectedRows.map((x) => x.ID);
        }
    };

    const handlePerRowsChange = async (page, newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        handleListData(page, perPage, searchtext, sortingId, sortingDirection);
    };

    const handleSort = (e, sortingDirection) => {
        setSortingId(e.id);
        setSortingDirection(sortingDirection);
        handleListData(searchtext);
    };

    const ChangeFilterText = (e) => {
        setSearchText(e.target.value);
        setCurrentPage(1);
        handleListData(e.target.value);
        console.log(handleListData);
    };

    useEffect(() => {
        handledropdwon();
        handleListData(searchtext);
    }, []);

    return (
        <>
            <Sidebar />
            <Loader loading={loading} />
            <div className="page-wrapper cardhead">
                <div className="content container-fluid">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row">
                            <div className="col">
                                <h3 className="page-title">Accounting</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/accounting">Accounting</Link>
                                    </li>
                                    <li className="breadcrumb-item active">AccountTypeDetails</li>
                                </ul>
                            </div>
                        </div>

                        {checkUserPermission(PERMISSION_ADD) ? (
                            <Link
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#ManageDataModal"
                                data-backdrop="static"
                                data-keyboard="false"
                                className="btn btn-added"
                                onClick={() => handleManageDataPopup()}
                            >
                                <i className="fa fa-plus me-2 lg"></i>Add AccountTypes Details

                            </Link>
                        ) : (
                            ""
                        )}
                    </div>

                    <div className="row">
                        <div className="row flex-row-reverse">
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
                                <input
                                    type="search"
                                    placeholder="Search..."
                                    className="search-btn form-control form-control-sm w-50 pull-right"
                                    onChange={ChangeFilterText}
                                    value={searchtext}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card mb-0">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            progressPending={loading}
                                            // pagination
                                            // paginationServer
                                            // paginationTotalRows={totalRows}
                                            // paginationDefaultPage={currentPage}
                                            // onChangeRowsPerPage={(e) => {
                                            //     handlePerRowsChange(1, e);
                                            // }}
                                            // onChangePage={handlePageChange}
                                            highlightOnHover
                                            striped
                                            responsive
                                            // paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                                            persistTableHead
                                        // sortServer
                                        // onSort={handleSort}
                                        // onSelectedRowsChange={(e) => {
                                        //     handleSelectedRowsChange(e);
                                        // }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="modal fade"
                        id="ManageDataModal"
                        tabIndex={-1}
                        aria-labelledby="upset"
                        aria-hidden="true"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                    >
                        <div
                            className="modal-dialog modal-lg modal-dialog-centered"
                            role="document"
                        >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Manage Account Types Details</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        {" "}
                                        <span aria-hidden="true">×</span>{" "}
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <Formik
                                        {...props}
                                        initialValues={formValues}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize
                                    >
                                        {({ values, errors, touched, handleChange }) => (
                                            <Form>
                                                <Field
                                                    type="hidden"
                                                    className="form-control"
                                                    id="ID"
                                                    name="ID"
                                                    value={values.ID}
                                                />
                                                <div className="form-group row">
                                                    <label className="col-form-label col-md-4">
                                                        Account Type
                                                    </label>
                                                    <div className="col-md-8">
                                                        <Select
                                                            backspaceRemovesValue={false}
                                                            controlShouldRenderValue={true}
                                                            hideSelectedOptions={true}
                                                            // isMulti={true}
                                                            isClearable={true}
                                                            onChange={setselectedAccountType}
                                                            options={AccountTypeList}
                                                            placeholder=""
                                                            styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                                            value={selectedAccountType}
                                                            id="AcoountTypes"
                                                            name="AcoountTypes"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row mt-3">
                                                    <label className="col-form-label col-md-4">
                                                        Account Type Details Name <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="col-md-8">
                                                        <Field
                                                            type="text"
                                                            className={`form-control ${errors.Name ? "is-invalid" : ""
                                                                }`}
                                                            id="Name"
                                                            name="Name"
                                                            onChange={handleChange}
                                                        />
                                                        <div className="invalid-feedback">
                                                            {touched.Name && errors.Name ? errors.Name : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pull-right mb-3">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary me-3"
                                                    >
                                                        Save
                                                    </button>
                                                    <Link
                                                        to="#"
                                                        className="btn btn-secondary btn-md me-1"
                                                        data-bs-dismiss="modal"
                                                    >
                                                        Cancel
                                                    </Link>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DeleteConfirmationModal
                deleteApiUrl={`${config.accountingBaseUrl}/chartofaccounts/accounttaxformdelete`}
            />
        </>

    );

}

export default AccountType;